import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

interface HtmlTextSetting {
    value: string;
    label: string;
    helptext?: string;
    required: boolean;
    minLength?: number;
    maxLength?: number;
    regex?: string;
    readonly: boolean;
    name: string;
}

@Component( {
    selector: 'his-html-text-job-setting',
    templateUrl: './his-html-text-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisHtmlTextJobSettingComponent {
    setting = input.required<HtmlTextSetting>();
    private baseGlobalService = inject( HisBaseGlobalsService );
    
    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    });

}
